import React, { useState } from 'react';

import { Alert, AlertTitle, Snackbar, } from '@mui/material';
import dayjs from 'dayjs';
import { HerokuURL } from '../../constants';
import AddEditUser from './addEditUserForm';
import Loader from '../general/loader';

const PendingUser = (props) => {

    const { history } = props; 
    const [userToEdit, setUserToEdit] = useState(props.location?.state?.userToEdit? props.location.state.userToEdit : {});
    const [showArrivingWithinThreeDays, setShowArrivingWithinThreeDays] = useState(false);

    const [loading, setLoading] = useState(false);
    const [snack, setSnack] = useState({ message: "", duration: 0, open: false, severity: "success" })



    const closeSnack = () => {
        setSnack({ ...snack, open: false });
    }

    const addNewSangat = async (sangat, resetForm) => {

        if (sangat.user_ride_from_airport === "YES") {
            // +utc 5:30 is the India timezone for arrival time where sangat will be landing
            if (Math.abs(dayjs().diff(dayjs(sangat.user_arrivingFlightDate + " " + sangat.user_arrivingFlightTime + "+05:30"), "hour")) <= 48) {
                setShowArrivingWithinThreeDays(true);
                return;
            }
        }
            setShowArrivingWithinThreeDays(false);
            setLoading(true);
            let saveUserResponse;

            saveUserResponse = fetch(`${HerokuURL}api/pendingUser/create`, {
                method: 'POST',
                headers: {
                    "x-access-token": localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    sangat
                ),
            })

            saveUserResponse.then((response) => response.json()).then((data) => {
                setSnack({ open: true, severity: "success", durration: 6000, message: data.user_firstName + " " + data.user_middleName + " " + data.user_lastName + " was successfully saved." })
                history.push('/');
                setLoading(false);
                if (resetForm) {
                    setUserToEdit({ ...sangat, _id: null, user_firstName: "", user_middleName: "", user_lastName: "", user_gender: "", user_yearOfBirth: null, user_ride_from_airport: "" });
                }
                history.push({
                    pathname: '/pending-user/' + data._id,
                    state: { sangat: data }
                });
            });



        
    }


    const onSaveCallBack = (sangat) => {
        addNewSangat(sangat, false);
    }

    const onSaveAndAddNewCallBack = (sangat) => {
        addNewSangat(sangat, true);

    }


    return (
        <>
            <Loader open={loading} />
            <h2>Submit Flight Information</h2>
            You must submit one form for each person.
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "center" }} open={snack.open} autoHideDuration={snack.duration} onClose={closeSnack}>
                <Alert onClose={closeSnack} variant="filled" severity={snack.severity} sx={{ width: '100%' }}>
                    {snack.message}
                </Alert>
            </Snackbar>
            {showArrivingWithinThreeDays &&
                <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={showArrivingWithinThreeDays} onClose={() => { setShowArrivingWithinThreeDays(false) }}>
                    <Alert variant="filled" onClose={() => { setShowArrivingWithinThreeDays(false) }} severity="error" sx={{ marginBottom: "16px" }} >
                        <AlertTitle>Warning!</AlertTitle>
                        You're arriving really soon! Sevadars may not be able to arrange your taxi. Please confirm with local sevadar at 919501487422.
                    </Alert>
                </Snackbar>}

            <AddEditUser key={userToEdit} sangat={userToEdit} title={"Submit Flight Information"} onSaveCallBack={onSaveCallBack} saveBtnText={"Save"} hideCloseBtn="true" fullScreen="true" />
        </>
    )
};


export default PendingUser;